// Shared USD currency formatter used by the My Account invoices/statement UI
// (on-screen tables) and its print-only counterpart.
export const currency = (n) =>
  Number(n || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
